import { render, staticRenderFns } from "./HomeIE.vue?vue&type=template&id=9623c3dc&"
import script from "./HomeIE.vue?vue&type=script&lang=js&"
export * from "./HomeIE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports